<template>
    <div class="share-detail">
        <div style="display: flex; align-items: center; padding: 16px">
            <div class="title-line"></div>
            <span class="title-content">份额明细</span>
        </div>
        <el-table
            :data="volList"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="销售机构" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.distributorname ? scope.row.distributorname : "" }}</span>
                </template>
            </el-table-column>
            <el-table-column label="支付银行卡" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.sourceflag == '1'">
                        {{
                            $cache.getDict("110080", scope.row.bankcode) +
                            "-" +
                            $cache.getDict("110079", scope.row.paycenterid) +
                            "(" +
                            scope.row.depositcard.substr(-4, 4) +
                            ")"
                        }}
                    </div>
                    <div v-else>
                        <span>--</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="资产(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持有份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="可用份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.usableremainshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="fundshowtype == 5" label="未转结收益" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.income) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="分红方式" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.sourceflag == '2'">请至代销机构修改</span>
                    <div v-else style="display: flex; justify-content: center">
                        <div
                            v-if="scope.row.isupdatedividend != '1'"
                            style="display: flex; align-items: center"
                        >
                            <div
                                v-if="
                                    (scope.row.fundtype == '04' &&
                                        scope.row.isupdatedividend !== '1') ||
                                    (scope.row.businessflag &&
                                        scope.row.businessflag.includes('00'))
                                "
                                style="margin-right: 4px; color: var(--color-text-regular); not-allowed;"
                            >
                                {{ $cache.getDict("110001", scope.row.dividendmethod) }}
                            </div>
                            <div
                                v-else-if="scope.row.isupdatedividend !== '1'"
                                style="display: flex; align-items: center"
                            >
                                <div
                                    style="
                                        margin-right: 4px;
                                        color: var(--color-text-regular);
                                        cursor: pointer;
                                    "
                                    v-on:click="changeDividendmethod(scope.row)"
                                >
                                    {{ $cache.getDict("110001", scope.row.dividendmethod) }}
                                </div>
                                <i
                                    aria-hidden="true"
                                    class="el-icon-arrow-right"
                                    style="color: var(--color-text-weak); cursor: pointer"
                                    v-on:click="changeDividendmethod(scope.row)"
                                ></i>
                            </div>
                        </div>

                        <div v-else style="cursor: not-allowed; color: var(--color-text-accent)">
                            <span>
                                {{
                                    $cache.getDict("110001", scope.row.perdefdividendmethod)
                                }}（待确认）
                            </span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";

export default {
    name: "ShareDetail",
    components: {},
    mixins: [mixin],
    props: {
        fundshowtype: {
            type: String,
            default: ""
        },
        volList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            list: []
        };
    },
    methods: {
        changeDividendmethod(val) {
            this.$emit("changeDividendmethod", val);
        }
    }
};
</script>

<style lang="scss" scoped>
.share-detail {
    margin-top: 20px;
    box-sizing: border-box;
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 0;
}
.el-table td.el-table__cell div {
    color: var(--color-text-primary);
}
.el-table td.el-table__cell span {
    color: var(--color-text-primary);
}
</style>
